const initialState = {
  isLoading: false,
  error: '',
  data: null,
};

export const getInterviewRequest = (state) => ({
  ...state,
  isLoading: true,
  error: '',
});

export const getInterviewSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: '',
    data: payload,
  };
};

export const getInterviewFailure = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: payload,
  };
};

export default initialState;
